import React from 'react';
import Icon from '../../../components/AppIcon';
import { PersonalInterest } from '../types';

interface PersonalInterestsSectionProps {
  personalInterests: PersonalInterest[];
}

const PersonalInterestsSection = ({ personalInterests }: PersonalInterestsSectionProps) => {
  return (
    <section className="bg-white border-2 border-[#0C2C39] shadow-[4px_4px_0px_0px_#0C2C39] rounded-[2rem] p-8 sm:p-12 mb-12 relative overflow-hidden">
      {/* Subtle Pattern Grid */}
      <div className="absolute inset-0 z-0 opacity-[0.02] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(#0C2C39 0.5px, transparent 0.5px)',
          backgroundSize: '24px 24px'
        }} />

      <h2 className="text-4xl sm:text-5xl font-black text-[#0C2C39] mb-12 flex items-center gap-4 relative z-10 font-roboto">
        <Icon name="Heart" size={32} className="text-teal-700" />
        Beyond the <span className="text-teal-700 italic">Code</span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 relative z-10">
        {personalInterests.map((interest) => (
          <div
            key={interest.id}
            className="group neubrutal-card bg-white p-8 transition-all duration-300"
          >
            <div className="w-14 h-14 rounded-2xl bg-[#0C2C39]/5 border-2 border-[#0C2C39] flex items-center justify-center text-[#0C2C39] mb-6 shadow-[2px_2px_0px_0px_#0C2C39] group-hover:shadow-none group-hover:bg-[#0C2C39] group-hover:text-white transition-all duration-300">
              <Icon name={interest.icon as any} size={24} />
            </div>
            <h3 className="text-xl font-black text-[#0C2C39] mb-3 tracking-tight">{interest.name}</h3>
            <p className="text-[#0C2C39]/70 text-sm leading-relaxed font-medium mb-6">{interest.description}</p>
            <div className="inline-block px-3 py-1 rounded-sm bg-[#0C2C39]/5 border border-[#0C2C39]/10 text-[10px] font-black uppercase tracking-widest text-[#0C2C39]/40">
              {interest.category}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PersonalInterestsSection;